import React from 'react'

import { Button } from 'ui/components/Button'

import { useCreateEmptyBlankPageModal } from './useCreateEmptyBlankPageModal'

type AddCustomPageButtonProps = React.ComponentPropsWithoutRef<typeof Button> & {}

export const AddCustomPageButton: React.FC<AddCustomPageButtonProps> = (props) => {
    const { show: handleAddPage } = useCreateEmptyBlankPageModal()

    return (
        <Button onClick={handleAddPage} {...props}>
            Add custom page
        </Button>
    )
}
